import React from "react";
import Image from "next/image";
import { navigate } from "@shared/utils.routing";
import { Button, Typography } from "@shared/ui.primitives";
import {
  quizInsertContainer,
  imageContainer,
  contentContainer,
  image
} from "./QuizInsert.css";
import { useQuizInsertTracking } from "./useQuizInsertTracking";

export const QuizInsert: React.FC = () => {
  const { trackingRef, trackQuizClick } = useQuizInsertTracking();

  const navigateToQuiz = () => {
    trackQuizClick();
    navigate("/quiz/skincare");
  };

  return (
    <div ref={trackingRef} className={quizInsertContainer}>
      <div className={imageContainer}>
        <Image
          alt="Quiz insert image"
          src="/images/search/quiz-insert.jpg"
          fill
          className={image}
        />
      </div>
      <div className={contentContainer}>
        <Typography as="p" variant="subheader-2" colour="primary-dark">
          Not sure what your skin needs?
        </Typography>
        <Typography as="p" variant="body-md" colour="primary-dark">
          Just take this quick and easy quiz to find the products that will work
          magic on your skin.
        </Typography>
        <Button
          onClick={navigateToQuiz}
          text="Take the Skincare Quiz"
          variant="secondary"
        />
      </div>
    </div>
  );
};
